import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);
export const platform = browser.getPlatform().type || "desktop"
export const os = browser.getOS().name || "Linux"
export const browserName = browser.getBrowser().name || "Chrome"
